import { render, staticRenderFns } from "./icon-link-minimal.vue?vue&type=template&id=8ef06f44&"
import script from "./icon-link-minimal.vue?vue&type=script&lang=js&"
export * from "./icon-link-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports